export { svgSpriteInline } from "./svgSpriteInline";
